import admin from './view';

export default [
  {
    path: '/',
    redirect: 'committee',
  },
  {
    path: 'committee', // 인증위원회개최현황
    redirect: 'committee/assign',
  },
  {
    path: 'committee/assign', // 위원회심의대상목록
    component: admin('/judge/memberList'),
  },
  {
    path: 'committee/assign/:sq', // 위원회심의대상현황 - 상세조회 및 관리
    component: admin('/judge/memberDetail'),
  },
  {
    path: 'committee/process', // 인증위원회개최현황
    redirect: 'committee/process/list',
  },
  {
    path: 'committee/process/list', // 인증위원회개최현황
    component: admin('/judge/committeeList'),
  },
  {
    path: 'committee/process/step', // 인증위원회개최 - 상정대상선정
    component: admin('/judge/committeeDetail'),
    children: [
      {
        path: 'target/:sq',
        component: admin('/judge/committeeTarget'),
        meta: { step: 0 },
      },
      {
        path: 'member/:sq',
        component: admin('/judge/committeeMember'),
        meta: { step: 1 },
      },
      {
        path: 'open/:sq',
        component: admin('/judge/committeeOpen'),
        meta: { step: 2 },
      },
    ],
  },
  {
    path: 'committee/process/status/:sq', // 인증위원회개최 - 상정대상선정
    component: admin('/judge/committeeStatus'),
  },
  {
    path: 'committee/process/result/:sq', // 인증위원회개최 - 상정대상선정
    component: admin('/judge/committeeResult'),
  },
  // {
  //   path: 'viewResult', // 인증위원회보기-업체별-심사위원별
  //   component: admin('/judge/viewResult'),
  // },
  {
    path: 'committeeUser/', // 인증위원관리
    component: admin('/judge/committeeUser'),
  },
  {
    path: 'committeeUser/register', // 인증위원 등록
    component: admin('/judge/committeeUserJoin'),
  },
  {
    path: 'committeeUser/:id', // 인증위원 상세보기
    component: admin('/judge/committeeUserDetail'),
  },
  {
    path: 'committeeUserEdit/:id', // 인증위원 정보수정
    component: admin('/judge/committeeUserEdit'),
  },
  {
    path: 'judgeUser', // 인증심사원관리
    component: admin('/judge/judgeUser'),
  },
  {
    path: 'judgeUser/register', // 인증심사원 등록
    component: admin('/judge/judgeUserJoin'),
  },
  {
    path: 'judgeUser/:id', // 인증심사원 상세보기
    component: admin('/judge/judgeUserDetail'),
  },
  {
    path: 'judgeUserEdit/:id', // 인증심사원 정보수정
    component: admin('/judge/judgeUserEdit'),
  },
  { path: '*', redirect: '/404' },
];



// WEBPACK FOOTER //
// ./src/router/admin/judge.js